import type { BorrowMarketDetail } from '@/utils/internalAppSdk'

export const getBorrowMarketCollateralSizeUsd = (market: BorrowMarketDetail, collateralMarketAssetId: string) => {
  const collateralAsset = market.assetsData.find((assetData) => assetData.marketAssetId === collateralMarketAssetId)
  return collateralAsset?.totalSupplied?.usd ? Number(collateralAsset.totalSupplied.usd) : 0
}
